package one.healthium.profile.ui.food.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.BasicText
import androidx.compose.foundation.text.TextAutoSize
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import loco.LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL
import loco.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL
import loco.LOG_FOOD_FOOD_DETAILS_FAT_LABEL
import loco.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL
import loco.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL
import one.healthium.profile.ui.food.models.AmountUiModel
import one.healthium.profile.ui.food.models.FoodUiModel
import one.healthium.profile.ui.food.models.FoodUiOptions
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_13
import org.jetbrains.compose.resources.stringResource
import androidx.compose.ui.tooling.preview.Preview
import kotlin.time.Clock

@Composable
fun FoodDetails(
    option: FoodUiOptions,
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(12.dp)
            .background(gray_13, AppTheme.shapes.small)
            .padding(horizontal = 12.dp)
    ) {
        Row {
            Column(
                modifier = Modifier
                    .weight(1f)
                    .padding(vertical = 12.dp),
                verticalArrangement = Arrangement.Top,
            ) {
                Text(
                    text = option.food.displayName,
                    style = AppTheme.textStyles.secondary_18_700,
                    color = AppTheme.colors.text100,
                    minLines = 2,
                    maxLines = 2,
                )
                Spacer(Modifier.height(8.dp))
                FoodDetailRow(
                    label = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL),
                    value = option.carbohydratesDisplayValue,
                )
                Spacer(Modifier.height(2.dp))
                FoodDetailRow(
                    label = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL),
                    value = option.proteinDisplayValue,
                )
                Spacer(Modifier.height(2.dp))
                FoodDetailRow(
                    label = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_FAT_LABEL),
                    value = option.fatDisplayValue,
                )
                Spacer(Modifier.height(2.dp))
                FoodDetailRow(
                    label = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL),
                    value = option.fiberDisplayValue,
                )
            }
            Column(
                modifier = Modifier
                    .padding(start = 8.dp, top = 12.dp, end = 12.dp)
                    .width(140.dp),
                horizontalAlignment = Alignment.End,
            ) {
                BasicText(
                    text = "${option.caloriesDisplayValue}",
                    style = AppTheme.textStyles.secondary_64_700.merge(
                        color = AppTheme.colors.text100,
                        textAlign = TextAlign.End,
                    ),
                    maxLines = 1,
                    autoSize = TextAutoSize.StepBased(
                        minFontSize = 16.sp,
                        maxFontSize = 64.sp,
                    ),
                )
                Text(
                    text = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL),
                    style = AppTheme.textStyles.secondary_18_700,
                    color = AppTheme.colors.text100,
                    textAlign = TextAlign.End,
                )
            }
        }
    }
}

@Composable
private fun FoodDetailRow(label: String, value: String) {
    Row {
        Text(
            text = label,
            style = AppTheme.textStyles.secondary_18_700,
            color = AppTheme.colors.text100,
        )
        Spacer(Modifier.width(4.dp))
        Text(
            text = value,
            style = AppTheme.textStyles.secondary_18_400,
            color = AppTheme.colors.text100,
        )
    }
}

@Composable
@Preview
private fun FoodDetailsPreview() {
    AppTheme {
        FoodDetails(
            option = FoodUiOptions(
                food = FoodUiModel.preview,
                amount = AmountUiModel.preview,
                date = Clock.System.now()
            )
        )
    }
}
